<template>
    <div class="HomeLogado">
        <HeaderLogado></HeaderLogado>

        <template v-if="!flVerificaAcesso">
            <div class="conteudo-sem-acesso">
                <div class="container">
                    <div class="row d-flex justify-content-center">
                        <div class="col-12 text-center">
                            <!--<div class="aviso-sem-acesso">
                                <span class="txt-h-1">Você ainda não tem acesso a este produto.</span>
                                <p class="txt-h-1 mb-0">Entre em contato com nossa equipe e adquira já!</p>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="flAcessoProduto">
            <div class="pesquisa">
                <!-- AVISO RECESSO -->
                <b-modal ref="modal-aviso-recesso" id="modalAvisoRecesso" size="xl" :hide-footer="true" :hide-header="true">
                    <div class="row">
                        <div class="col-6">
                            <span class="txt-p txt-roxo-1 txt-size-20 txt-w-bold mb-2">
                                Aviso
                            </span>
                        </div>
                        <div class="col-6">
                            <div class="w-100 text-end txt-size-20 txt-cores-6">
                                <span @click="hideAvisoRecesso"><i class="fas fa-times c-pointer"></i></span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row mt-3">

                        <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                            Recesso fim de ano 2024
                        </p>
                        <br />
                        <br />
                        <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                            Prezados Solicitantes
                        </p>
                        <br />
                        <br />
                        <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                            Informamos que o setor Jurídico do Sollicita entrará em recesso no dia <span class="txt-w-bold">18/12/24</span> (18 de Dezembro de 2024), retornando as suas atividades em <span class="txt-w-bold">08/01/25</span> (8 de Janeiro de 2025).
                        </p>
                        <br />
                        <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                            Durante o referido período não serão prestados atendimentos nem computados prazos, conforme previsto pelo Método de Trabalho.
                        </p>
                        <br />
                        <br />
                        <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                            Aproveitamos a oportunidade para desejar a todos um Feliz Natal e um 2025 de muito sucesso!
                        </p>
                        <br />
                        <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                            Cordialmente,
                        </p>
                        <br />
                        <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                            Equipe Técnica
                        </p>
                    </div>
                </b-modal>

                <div class="container">
                    <div class="row d-flex justify-content-center">
                        <div class="col-12 col-md-8 text-center" style="position: relative;">
                            <span class="txt-p txt-white txt-size-20 txt-w-bold">
                                Faça sua busca!
                            </span>
                            <p class="txt-p txt-size-16 txt-white ">
                                Sua pergunta já pode ter sido respondida, consulte nosso acervo!
                            </p>
                            <div class="input-group my-3">
                                <input type="text" class="form-control" placeholder="Buscar nas perguntas" aria-label="Buscar nas perguntas" aria-describedby="basic-addon2" v-model="busca" style="border-right: none;">
                                <span class="input-group-text bg-white txt-cores-2" id="basic-addon2"><i class="fas fa-search"></i></span>
                            </div>
                            <button class="btn btn-roxo w-100 mb-5" @click="pesquisa">Buscar</button>

                            <div class="w-100 position-relative">
                                <div class="box-nova-pergunta" v-if="utilizacoes && utilizacoes.permiteRealizarPerguntas">
                                    <div class="row">
                                        <div class="col-12 col-md-4 m-auto">
                                            <span class="txt-p txt-cores-1 txt-size-16 txt-w-bold">
                                                ...ou crie sua pergunta!
                                            </span>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <button class="btn btn-roxo-outline w-100" @click="showModal = !showModal">
                                                <i class="fas fa-plus"></i> Nova pergunta
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
            <div class="my-4" v-if="utilizacoes != null">
                <div class="container">
                    <div class="row d-flex justify-content-center">
                        <div class="col-12 col-md-8 mt-5">
                            <span class="txt-p txt-cores-6 ">
                                Total de perguntas realizadas: <b>{{utilizacoes.qtdRealizadosTotal}}</b>
                            </span>
                            <p class="txt-p txt-cores-6 ">
                                Total de perguntas realizadas durante o contrato vigente: <b>{{utilizacoes.qtdRealizados}}</b> de <b>{{utilizacoes.qtdLiberados}}</b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="conteudo-home">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <span class="txt-p txt-size-16 txt-w-bold txt-cores-1">
                                Perguntas realizadas
                            </span>
                        </div>
                    </div>
                    <div class="row  mb-4" v-if="orientacoes != null && orientacoes.length == 0">
                        <div class="col-12 text-center mt-4">
                            <p class="txt-p txt-roxo-1 txt-w-5 txt-size-18">Nenhuma pergunta encontrada!</p>
                        </div>
                    </div>
                    <div class="row mb-4" v-else>
                        <div class="col-12 col-lg-4 mt-4" v-for="(item) in orientacoes" :key="item.idPergunta">
                            <div class="box-orientacao">
                                <div class="body-box-orientacao">
                                    <div style="height: 70px;">
                                        <span class="txt-p txt-size-16 txt-cores-6 txt-w-bold reduz-texto-3">
                                            {{item.dsAssunto}}
                                        </span>
                                    </div>

                                    <div class="divisor"></div>

                                    <div class="row">
                                        <div class="col-4">
                                            <div class="d-flex justify-content-center">
                                                <i class="fas fa-calendar-alt txt-roxo-1 txt-size-28"></i>
                                            </div>
                                            <div class="d-flex justify-content-center align-items-center my-2" style="height: 40px">
                                                <span class="txt-p txt-w-500 txt-cores-1 ">Solicitado</span>
                                            </div>
                                            <div class="d-flex justify-content-center">
                                                <span class="txt-p txt-w-bold txt-cores-1 txt-size-16 text-center">{{item.dtPerguntaFormat}}</span>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="d-flex justify-content-center">
                                                <i class="fas fa-hourglass txt-roxo-1 txt-size-28"></i>
                                            </div>
                                            <div class="d-flex justify-content-center align-items-center my-2 text-center" style="height: 40px">
                                                <span class="txt-p txt-w-500 txt-cores-1 " v-if="item.perguntaEtapa.nmEtapa == 'Finalizada' || item.perguntaEtapa.nmEtapa == 'Cancelada'">Previsto</span>
                                                <span class="txt-p txt-w-500 txt-cores-1 " v-else>Conclusão prevista</span>
                                            </div>
                                            <div class="d-flex justify-content-center">
                                                <span class="txt-p txt-w-bold txt-cores-1 txt-size-16 text-center" v-if="item.dtPrazo == null && item.perguntaEtapa.nmEtapa == 'Complemento'">Aguardando</span>
                                                <span class="txt-p txt-w-bold txt-cores-1 txt-size-16 text-center" v-else>{{item.dtPrazoFormat}}</span>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="d-flex justify-content-center">
                                                <i class="fas fa-calendar txt-roxo-1 txt-size-28" v-if="item.perguntaEtapa.nmEtapa == 'Finalizada' || item.perguntaEtapa.nmEtapa == 'Cancelada'"></i>
                                                <i class="fas fa-calendar-check txt-roxo-1 txt-size-28" v-else></i>
                                            </div>
                                            <div class="d-flex justify-content-center align-items-center my-2 text-center" style="height: 40px">
                                                <span class="txt-p txt-w-500 txt-cores-1 " v-if="item.perguntaEtapa.nmEtapa == 'Finalizada' || item.perguntaEtapa.nmEtapa == 'Cancelada'">Finalizado</span>
                                                <span class="txt-p txt-w-500 txt-cores-1 " v-else>Última interação</span>
                                            </div>
                                            <div class="d-flex justify-content-center">
                                                <span class="txt-p txt-w-bold txt-cores-1 txt-size-16 text-center">{{item.dtMovimento}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="divisor"></div>

                                    <div class="status" v-if="item.perguntaEtapa.nmEtapa == 'Abertura' || item.perguntaEtapa.nmEtapa == 'Andamento' || item.perguntaEtapa.nmEtapa == 'Encaminhada'">
                                        <div class="text-center my-2">
                                            <span class="txt-p txt-w-5 txt-size-18 txt-info">
                                                <i class="fas fa-hourglass"></i> Aguardando atendimento
                                            </span>
                                        </div>
                                        <div class="descricao-status">
                                            <span class="txt-p txt-cores-6 txt-size-14">
                                                Sua pergunta foi encaminhada para a nossa equipe, e está em processo de atendimento.
                                            </span>
                                        </div>
                                    </div>

                                    <div class="status" v-else-if="item.perguntaEtapa.nmEtapa == 'Iniciada'">
                                        <div class="text-center my-2">
                                            <span class="txt-p txt-w-5 txt-size-18 txt-info">
                                                <i class="fas fa-hourglass"></i> Aguardando resposta
                                            </span>
                                        </div>
                                        <div class="descricao-status">
                                            <span class="txt-p txt-cores-6 txt-size-14">
                                                Sua pergunta foi encaminhada para a nossa equipe, e está em processo de atendimento.
                                            </span>
                                        </div>
                                    </div>

                                    <div class="status" v-else-if="item.perguntaEtapa.nmEtapa == 'Complemento'">
                                        <div class="text-center my-2">
                                            <span class="txt-p txt-w-5 txt-size-18 txt-info">
                                                <i class="fa fa-reply ico-retorno"></i> Aguardando Retorno
                                            </span>
                                        </div>
                                        <div class="descricao-status">
                                            <span class="txt-p txt-cores-6 txt-size-14">
                                                Necessitamos que sua pergunta seja complementada para melhor atendimento de nossa equipe, Por favor complemente sua pergunta.
                                            </span>
                                        </div>
                                    </div>

                                    <div class="status" v-else-if="item.perguntaEtapa.nmEtapa == 'Finalizada'">
                                        <div class="text-center my-2">
                                            <span class="txt-p txt-w-5 txt-size-18 txt-sucess">
                                                <i class="fas fa-envelope"></i> Respondido
                                            </span>
                                        </div>
                                        <div class="descricao-status">
                                            <span class="txt-p txt-cores-6 txt-size-14">
                                                Sua pergunta foi respondida! Clique em <b>Visualizar Informações</b> para ter acesso a resposta.
                                            </span>
                                        </div>
                                    </div>

                                    <div class="status" v-else-if="item.perguntaEtapa.nmEtapa == 'Cancelada'">
                                        <div class="text-center my-2">
                                            <span class="txt-p txt-w-5 txt-size-18 txt-erro">
                                                <i class="fas fa-times"></i> Cancelado
                                            </span>
                                        </div>
                                        <div class="descricao-status">
                                            <span class="txt-p txt-cores-6 txt-size-14">
                                                Sua pergunta foi cancelada. Por favor, verifique o motivo clicando em <b>Visualizar Informações</b>.
                                            </span>
                                        </div>
                                    </div>

                                    <div class="status" v-else>
                                        <div class="w-100 text-center my-2">
                                            <span class="txt-p txt-w-5 txt-size-18 txt-cores-6">
                                                <i class="fas fa-sync-alt"></i> Sem dados
                                            </span>
                                        </div>
                                        <div class="descricao-status">
                                            <span class="txt-p txt-cores-6 txt-size-14">
                                                Não foi possível carregar sua pergunta, entre em contato com o suporte para mais informações.
                                            </span>
                                        </div>
                                    </div>

                                </div>


                                <div class="footer-box-orientacao c-pointer" @click="detalhes(item.idPergunta)">
                                    <i class="fas fa-eye me-2"></i> Visualizar informações
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <NovaOrientacao :showModal="showModal" :recarregaHome="load" :flCortesia="utilizacoes.flCortesia" v-if="utilizacoes"></NovaOrientacao>
        </template>
        <template v-else>
            <div class="conteudo-sem-acesso">
                <div class="container">
                    <div class="row d-flex justify-content-center">
                        <div class="col-12 text-center">
                            <div class="aviso-sem-acesso">
                                <span class="txt-h-1">Você ainda não tem acesso a este produto.</span>
                                <p class="txt-h-1 mb-0">Entre em contato com nossa equipe e adquira já!</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </template>


        <Footer></Footer>
    </div>
</template>

<script>
    import HeaderLogado from '@/components/HeaderLogado'
    import Footer from '@/components/Footer'
    import NovaOrientacao from '@/components/NovaOrientacao'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'HomeLogado',
        components: { HeaderLogado, Footer, NovaOrientacao },
        props: {
            termo: String,
        },
        computed: {

            flVerificaAcesso() {
                return this.$store.state.flVerificaAcesso
            },
            
            flAcessoProduto() {
                return this.$store.state.flAcessoProduto
            },

        },
        data: function () {
            return {
                orientacoes: null,
                utilizacoes: null,
                showModal: false,

                loading: null,
                busca: null,
            }
        },
        
        methods: {
            detalhes(id) {
                this.$router.push({ name: 'Orientacao', params: { id: id } })
            },

            pesquisa() {
                if (this.busca != "") {
                    this.$router.push({ name: 'Pesquisa', params: { termo: this.busca } });
                }
            },


            load() {
                this.loading = this.$loading.show({});
                let $this = this;                
                axios.get(`${urlApi}/Pergunta/Get`, { showLoading: false, params: { termo: $this.busca } })
                    .then(res => {
                        if (res.data.success) {
                            $this.orientacoes = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];
                                item.dtPerguntaFormat = moment(item.dtPergunta).format('DD/MM/YYYY [às] HH:mm');
                                item.dtPrazoFormat = moment(item.dtPrazo).format('DD/MM/YYYY [às] HH:mm');
                                if (item.perguntaMovimento != null) {
                                    item.dtMovimento = moment(item.perguntaMovimento.dtMovimento).format('DD/MM/YYYY [às] HH:mm');
                                } else {
                                    item.dtMovimento = null;
                                }
                                
                                $this.orientacoes.push(item);
                            }
                            
                        } else {
                            avisoErro("Não foi possível carregar suas orientações.");
                        }

                        $this.carregaUtilizacoes();
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Pergunta/Utilizacoes`,{ showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            
                            $this.utilizacoes = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar suas orientações.");
                        }
                        $this.loading.hide();
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            showAvisoRecesso() {
                this.$refs['modal-aviso-recesso'].show();
            },

            hideAvisoRecesso() {
                this.$refs['modal-aviso-recesso'].hide();
            },
            
        },
        created: function () {
            this.busca = this.termo;
            this.load();

            // LOG ACESSO PRODUTO
            axios.post(`${urlApi}/Log/AcessoProduto`, { 'cdProduto': 'SO' });

            // aviso recesso
            let $this = this;
            let hoje = moment();
            if (hoje >= moment('2024-12-12') && hoje < moment('2025-01-08 09:00:00')) {
                setTimeout(function () {
                    $this.showAvisoRecesso();
                }, 1000);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .conteudo-home {
        min-height: 46vh;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
/*
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }*/

    .HomeLogado {
        background-color: #E5E5E5;
    }

    .pesquisa {
        background: linear-gradient(98.19deg, #163142 1.55%, #281D2E 61.54%, #163142 100%);
        padding: 50px 0;

    }

    .box-nova-pergunta {
        background: #FFFFFF;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        padding: 25px 15px;

        width: 100%;

        position: absolute;
    }


    .box-orientacao {
        background: #FFFFFF;
        border: 3px solid #732A90;
        box-sizing: border-box;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;

        
        position: relative;
    }

    .box-orientacao .body-box-orientacao {
        padding: 30px;
    }

    .box-orientacao .body-box-orientacao .divisor {
        width: 100%;
        border-bottom: 1px solid #DADADA;
        margin: 15px 0;
    }

    .box-orientacao .footer-box-orientacao {
        background: #732A90;
        border-radius: 0 0 4px 4px;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 14px;
    }

    .box-orientacao .body-box-orientacao .status .descricao-status {
        display: flex;
        justify-content: center;
        height: 60px;
    }

    .conteudo-sem-acesso {
        background: linear-gradient(98.19deg, #163142 1.55%, #281D2E 61.54%, #163142 100%);
        padding: 50px 0;
        height: 52.7vh;
        display: flex;
        align-items: center;
    }

    .aviso-sem-acesso {
        background: #FFFFFF;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        padding: 2rem 10px;
    }
    
</style>

